import React from "react";
import {
  Box,
  Button,
  ButtonBase,
  Dialog,
  DialogContent,
  Slide,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { BRAND } from "../auth/authTheme";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const SheetHandle = () => (
  <Box sx={{ display: "flex", justifyContent: "center", pt: 1.25, pb: 0.75 }}>
    <Box sx={{ width: 40, height: 4, borderRadius: 2, bgcolor: BRAND.border }} />
  </Box>
);

export const FilterButton = ({ label, onClick, minWidth, isActive, disabled, flex = 1 }) => (
  <ButtonBase
    onClick={onClick}
    disabled={disabled}
    sx={{
      flex: minWidth ? undefined : flex,
      minWidth: minWidth || 0,
      width: minWidth ? minWidth : "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 0.5,
      px: 1.5,
      py: 1.1,
      bgcolor: disabled ? BRAND.bg : isActive ? BRAND.orangeLight : "#fff",
      borderRadius: "10px",
      border: `1px solid ${isActive ? BRAND.orangeHover : BRAND.border}`,
      fontSize: "0.8125rem",
      fontWeight: 600,
      color: disabled ? BRAND.muted : BRAND.navy,
      minHeight: 52,
      transition: "border-color 0.15s, background-color 0.15s",
      opacity: disabled ? 0.7 : 1,
    }}
  >
    <Box
      component="span"
      sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
    >
      {label}
    </Box>
    <ExpandMoreIcon sx={{ fontSize: "1.2rem", color: BRAND.muted, flexShrink: 0 }} />
  </ButtonBase>
);

export const PickerOption = ({ label, isSelected, onClick }) => (
  <ButtonBase
    onClick={onClick}
    sx={{
      py: 1.15,
      borderRadius: "10px",
      fontWeight: 600,
      fontSize: "0.8125rem",
      color: isSelected ? "#fff" : BRAND.navy,
      bgcolor: isSelected ? BRAND.orangeHover : "#fff",
      border: `1px solid ${isSelected ? BRAND.orangeHover : BRAND.border}`,
      boxShadow: isSelected ? "0 2px 8px rgba(230, 90, 0, 0.22)" : "none",
      transition: "transform 0.12s, background-color 0.15s, border-color 0.15s",
      "&:active": { transform: "scale(0.97)" },
    }}
  >
    {label}
  </ButtonBase>
);

export const PickerSheet = ({
  open,
  onClose,
  title,
  subtitle,
  preview,
  previewLabel = "Selected",
  children,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    TransitionComponent={Transition}
    fullWidth
    maxWidth="xs"
    sx={{
      "& .MuiDialog-container": { alignItems: "flex-end" },
      "& .MuiBackdrop-root": { bgcolor: "rgba(26, 43, 74, 0.45)" },
    }}
    PaperProps={{
      sx: {
        m: 0,
        width: "100%",
        maxWidth: "100%",
        bgcolor: "#fff",
        borderRadius: "16px 16px 0 0",
        pb: "max(env(safe-area-inset-bottom), 8px)",
        maxHeight: "82vh",
      },
    }}
  >
    <SheetHandle />
    <Box sx={{ px: 2, pb: 0.5 }}>
      <Typography sx={{ fontWeight: 700, color: BRAND.navy, fontSize: "1.0625rem" }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography sx={{ fontSize: "0.8125rem", color: BRAND.muted, mt: 0.25 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    <DialogContent sx={{ px: 2, pt: 1, pb: 1.5 }}>{children}</DialogContent>
    {preview && (
      <Box
        sx={{
          mx: 2,
          mb: 1,
          py: 1,
          px: 1.25,
          borderRadius: "10px",
          bgcolor: BRAND.orangeLight,
          border: `1px solid ${BRAND.orangeHover}33`,
          textAlign: "center",
        }}
      >
        <Typography sx={{ fontSize: "0.6875rem", color: BRAND.muted, fontWeight: 600 }}>
          {previewLabel}
        </Typography>
        <Typography sx={{ fontSize: "0.9375rem", fontWeight: 700, color: BRAND.navy }}>
          {preview}
        </Typography>
      </Box>
    )}
    <Box
      sx={{
        px: 2,
        pt: 0.5,
        pb: 1,
        borderTop: `1px solid ${BRAND.border}`,
      }}
    >
      <Button
        onClick={onClose}
        variant="outlined"
        color="inherit"
        fullWidth
        sx={{
          minHeight: 44,
          borderRadius: "12px",
          textTransform: "none",
          fontWeight: 600,
          borderColor: BRAND.border,
          color: BRAND.navy,
        }}
      >
        Done
      </Button>
    </Box>
  </Dialog>
);
